import {useState, useRef, useEffect} from "react";
import {
    AUTH_FLOW_UNKNOWN as UNKNOWN,
    AUTH_FLOW_NON_SSO as NON_SSO,
    AUTH_FLOW_SSO as SSO,
    GATEWAY_URL,
    ACVL_APPLICATION_ID,
} from "ubcommunity-shared/src/constants";
import removeTrailingSlash from "ubcommunity-shared/src/Utils/remove-trailing-slash";

type AcvlResponse = {
    redirect_url: string;
};

const URL = `${removeTrailingSlash(GATEWAY_URL)}/acvl/clients/${ACVL_APPLICATION_ID}-/redirect-url`;

const getRedirectUrlFromAcvlResponse = ({
    redirect_url: redirectUrl = null,
}: AcvlResponse): string | null => redirectUrl;

export default function useLoginFlow(): {
    flow: string;
    redirectUrl: string | null;
    error: string | null;
} {
    const [flow, setFlow] = useState(UNKNOWN);
    const [redirectUrl, setRedirectUrl] = useState(null);
    const [error, setError] = useState(null);
    const acvlRequest = useRef(null);

    useEffect(() => {
        if (acvlRequest.current) return;
        acvlRequest.current = fetch(URL, {credentials: "include"})
            .then((response: Response): Promise<AcvlResponse> | Record<never, never> => {
                const {status} = response;

                if (status === 200) {
                    setFlow(SSO);
                    return response.json();
                }

                if (status === 404) {
                    setFlow(NON_SSO);
                    return {};
                }

                throw new Error(`Gateway status not expected. Recieved "${status}"`);
            })
            .then((acvlResponse: AcvlResponse & Record<never, never>) => {
                setRedirectUrl(getRedirectUrlFromAcvlResponse(acvlResponse));
                setError(null);
            })
            .catch(({message}) => {
                setRedirectUrl(null);
                setError(message);
            });
    }, [flow, redirectUrl]);

    return {flow, redirectUrl, error};
}
